import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralModule } from '../../modules/general.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReingresarDialog } from './reingresar-dialog.component';

@NgModule({
	exports: [ReingresarDialog],
	imports: [
		// CommonModule,
		FormsModule,
		// GeneralModule,
		MatDialogModule,
		MatTooltipModule,
		MatTabsModule,
		MatButtonModule,
		MatInputModule,
		MatIconModule,
		ReactiveFormsModule,
	],
	declarations: [ReingresarDialog],
	providers: [],
	entryComponents: [],
})
export class IngresarDialogModule {}
